import { render, staticRenderFns } from "./FieldCustomerIdentification.vue?vue&type=template&id=703c391e&"
import script from "./FieldCustomerIdentification.vue?vue&type=script&lang=js&"
export * from "./FieldCustomerIdentification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports